<app-checkout-layout
  [title]="'checkout.summary.title' | translate"
  [backLinkAriaLabel]="'checkout.summary.back_link' | translate"
  [backLink]="backLink"
  data-test="summary-page"
>
  <div *ngIf="items" class="col-span-12 md:col-start-2 md:col-end-7">
    <app-checkout-summary
      [items]="items"
      [isImageDisplayed]="false"
      [showExternalPayment]="showExternalPayment"
      [isVatDisplayed]="true"
      [isCart]="false"
      [usedInMultibooking]="false"
    ></app-checkout-summary>
  </div>

  <ng-container *ngIf="!isFreeCheckoutAndNotLogged">
    <form [formGroup]="summaryForm" (ngSubmit)="confirm()">
      <app-form-checkbox
        class="block mt-4 mb-4"
        formControlName="termsOfService"
        [align]="checkboxAlign"
        [hasError]="summaryForm?.invalid && summaryForm?.touched"
        [required]="true"
        label="{{ 'checkout.summary.conditions' | translate }}"
        data-test="input-ToS"
      ></app-form-checkbox>

      <app-form-checkbox
        *ngIf="showExternalPayment"
        class="block mt-4 mb-4"
        formControlName="allowExternalPaymentChecker"
        [align]="checkboxAlign"
        [hasError]="summaryForm.invalid && summaryForm.dirty"
        [required]="true"
        label="{{
          'checkout.summary.checkbox.allow_external_payment' | translate
        }}"
      ></app-form-checkbox>

      <app-mobile-fixed-panel [parentElementRef]="appSummaryElementRef">
        <button
          app-vtmn-play-button
          type="submit"
          [type]="ctaButtonType.Submit"
          [size]="vtmnPlayButtonSize.MEDIUM"
          loading
          [disabled]="summaryForm.invalid ? true : null"
          [attr.data-disabled]="summaryForm.invalid ? true : null"
          data-test="submit-summary-form"
        >
          {{ ctaSubmit | translate }}
        </button>
      </app-mobile-fixed-panel>
    </form>
  </ng-container>

  <ng-container *ngIf="isFreeCheckoutAndNotLogged">
    <p class="mt-4 mb-4">
      {{ 'checkout.summary.free_activity.not_logged.text' | translate }}
    </p>

    <app-mobile-fixed-panel>
      <button
        app-vtmn-play-button
        type="button"
        [type]="ctaButtonType.Button"
        [size]="vtmnPlayButtonSize.MEDIUM"
        (click)="login()"
      >
        {{ 'checkout.summary.free_activity.not_logged.button' | translate }}
      </button>
    </app-mobile-fixed-panel>
  </ng-container>

  <app-tips
    *ngIf="showExternalPayment"
    class="md:mt-5 md:block"
    [title]="
      'checkout.subscription.information_box.allow_external_payment.header'
        | translate
    "
    [tips]="
      'checkout.subscription.information_box.allow_external_payment.description'
        | translate
    "
  ></app-tips>

  <app-tips
    *ngIf="items"
    class="md:mt-5 md:block"
    [title]="'checkout.subscription.information_box.header' | translate"
    [tips]="
      'checkout.subscription.information_box.description'
        | translate: { refundTime: getFormattedRefundTime }
    "
  >
  </app-tips>

  <div *ngIf="items" class="mt-7 hidden md:block" right-column #rightColumn>
    <!-- Image -->
    <img
      *ngFor="let item of items"
      class="w-full rounded"
      [src]="getPicture(item.activity)"
      alt=""
    />
  </div>
</app-checkout-layout>
